var map = {
	"./5570834.jpg": 61163,
	"./carousel.zip": 5506,
	"./carousel/1.webp": 75419,
	"./carousel/1_mo.webp": 61740,
	"./carousel/2_land.avif": 18224,
	"./carousel/3.avif": 43207,
	"./carousel/3_mo.avif": 84680,
	"./carousel/carousel1.jpeg": 11372,
	"./carousel/carousel10.jpg": 21051,
	"./carousel/carousel11.jpg": 89566,
	"./carousel/carousel12.HEIC": 93434,
	"./carousel/carousel12.jpg": 16297,
	"./carousel/carousel2.jpg": 41428,
	"./carousel/carousel3.jpg": 19953,
	"./carousel/carousel4.jpg": 23394,
	"./carousel/carousel5.jpg": 43391,
	"./carousel/carousel6.jpeg": 42393,
	"./carousel/carousel6.jpg": 28432,
	"./carousel/carousel7.HEIC": 8608,
	"./carousel/carousel7.jpg": 71885,
	"./carousel/carousel8.HEIC": 84445,
	"./carousel/carousel8.jpg": 56878,
	"./carousel/carousel9.jpg": 83339,
	"./carousel/carousel_mo_1.jpg": 54161,
	"./carousel/carousel_mo_1.webp": 77575,
	"./carousel/carousel_mo_2.jpg": 12742,
	"./carousel/carousel_mo_3 - Copy.webp": 3455,
	"./carousel/carousel_mo_3.JPG": 94472,
	"./carousel/carousel_mo_4.webp": 22792,
	"./carousel/carousel_mo_5.jpg": 94189,
	"./carousel/carousel_mo_6.jpg": 64930,
	"./carousel/code.HEIC": 36094,
	"./carousel/code_surge.jpg": 10118,
	"./carousel/desktop.ini": 80864,
	"./carousel/replicon.jpg": 19806,
	"./carousel/replicon.png": 66042,
	"./carousel/wcc3_car.webp": 57949,
	"./carousel/wcc3_car_mo.webp": 88322,
	"./carousel/webthon2.jpg": 13875,
	"./carousel/webthon2.png": 7611,
	"./carousel/webthon2_mo.png": 29156,
	"./desktop.ini": 80773,
	"./events5.zip": 68530,
	"./events5/1 (4).jpeg": 97123,
	"./events5/1 (5).jpeg": 81958,
	"./events5/15.jpeg": 70539,
	"./events5/2 (3).jpeg": 3589,
	"./events5/2 (4).jpeg": 80438,
	"./events5/2018.jpg": 61705,
	"./events5/2021.jpeg": 79634,
	"./events5/24_0 (1).JPG": 10782,
	"./events5/24_0 (2).jpg": 596,
	"./events5/24_1.jpg": 94386,
	"./events5/24_1.webp": 45770,
	"./events5/24_10.HEIC": 1649,
	"./events5/24_10.jpg": 71296,
	"./events5/24_11.HEIC": 77382,
	"./events5/24_11.jpg": 22429,
	"./events5/24_2.jpg": 13341,
	"./events5/24_3.jpg": 87776,
	"./events5/24_4.jpg": 28083,
	"./events5/24_5.jpg": 56470,
	"./events5/24_6.HEIC": 38040,
	"./events5/24_6.jpg": 6081,
	"./events5/24_7.jpg": 28036,
	"./events5/24_8.HEIC": 77530,
	"./events5/24_8.jpg": 99895,
	"./events5/24_9.HEIC": 44101,
	"./events5/24_9.jpg": 28730,
	"./events5/25_0.avif": 92432,
	"./events5/25_1.avif": 3295,
	"./events5/25_13.jpg": 98024,
	"./events5/25_14.jpg": 79611,
	"./events5/25_15.jpg": 78302,
	"./events5/25_16.avif": 67707,
	"./events5/25_17.avif": 99596,
	"./events5/25_18.jpg": 63471,
	"./events5/25_19.avif": 85790,
	"./events5/25_2.avif": 26774,
	"./events5/25_20.avif": 6238,
	"./events5/25_3.avif": 56517,
	"./events5/25_4.avif": 2908,
	"./events5/25_5.avif": 54731,
	"./events5/25_6.avif": 32562,
	"./events5/25_7.avif": 69825,
	"./events5/25_8.avif": 25352,
	"./events5/2_land.avif": 41504,
	"./events5/3 (4).jpeg": 94789,
	"./events5/3 (5).jpeg": 57096,
	"./events5/3 (6).jpeg": 74439,
	"./events5/3.avif": 26711,
	"./events5/4 (3).jpeg": 48899,
	"./events5/4 (4).jpeg": 78424,
	"./events5/ACM.png": 51363,
	"./events5/ACM.webp": 97855,
	"./events5/CodingNexus1.jpg": 98000,
	"./events5/acm_code_heist.jpeg": 99038,
	"./events5/agentic_ai_1.png": 43816,
	"./events5/agentic_ai_2.png": 29091,
	"./events5/agentic_ai_3.png": 27866,
	"./events5/ai_1.jpg": 31894,
	"./events5/ai_continuum_0.jpg": 33894,
	"./events5/ai_continuum_1.jpg": 77027,
	"./events5/ai_continuum_2.jpg": 30964,
	"./events5/aihackday.jpg": 44971,
	"./events5/api.jpeg": 10319,
	"./events5/artifical.jpeg": 88508,
	"./events5/cb1.jpg": 33462,
	"./events5/cb2.jpg": 25601,
	"./events5/cb3.jpg": 35652,
	"./events5/cb4.jpg": 78383,
	"./events5/cb5.jpg": 2002,
	"./events5/cb6.jpg": 56157,
	"./events5/cbc.jpg": 76244,
	"./events5/cbc1.jpg": 62867,
	"./events5/cbc2.jpg": 11236,
	"./events5/cc.jpeg": 15083,
	"./events5/code_heist_2.jpeg": 43347,
	"./events5/code_hest_1.jpeg": 99097,
	"./events5/code_surge_1.png": 23356,
	"./events5/code_surge_2.png": 12087,
	"./events5/code_surge_poster.png": 5278,
	"./events5/codeignite.jpg": 63537,
	"./events5/coding101.jpg": 69816,
	"./events5/coding101_1.jpg": 35016,
	"./events5/coding101_2.jpg": 3415,
	"./events5/coding101_3 (1).jpg": 92468,
	"./events5/coding101_3 (1).webp": 12630,
	"./events5/coding101_3.jpg": 55930,
	"./events5/codingblitz.jpg": 7413,
	"./events5/codingblitz_1.JPG": 81640,
	"./events5/codingblitz_2.JPG": 66647,
	"./events5/codingblitz_3.JPG": 47738,
	"./events5/codingnexus.jpg": 37809,
	"./events5/codingnexus2.jpg": 34367,
	"./events5/codingworkshop.jpg": 98297,
	"./events5/codingworkshop_2.jpg": 74270,
	"./events5/codingworshop_1.jpg": 29980,
	"./events5/competative.jpeg": 85904,
	"./events5/conquestor.jpg": 97733,
	"./events5/conv.jpg": 25298,
	"./events5/cyberark.jpeg": 83886,
	"./events5/cyberark_1.jpeg": 12574,
	"./events5/deep.jpg": 93610,
	"./events5/deep_1.jpg": 62606,
	"./events5/deep_2.jpg": 42873,
	"./events5/desktop.ini": 99376,
	"./events5/eval1.jpg": 17445,
	"./events5/eval2.jpg": 29594,
	"./events5/eval3.jpg": 759,
	"./events5/eval4.jpg": 94444,
	"./events5/eval5.jpg": 66057,
	"./events5/eval6.jpg": 70110,
	"./events5/expo.jpeg": 81257,
	"./events5/expo_1.jpeg": 7369,
	"./events5/expo_2.jpeg": 76040,
	"./events5/favicon.ico": 45005,
	"./events5/fundamentals.jpeg": 78973,
	"./events5/grow.jpeg": 53490,
	"./events5/grow1.jpeg": 96541,
	"./events5/hackathon.jpg": 22661,
	"./events5/illum1.jpg": 63036,
	"./events5/illum2.jpg": 30731,
	"./events5/illum3.jpg": 4270,
	"./events5/illum5.jpg": 7896,
	"./events5/illum_1.jpg": 52045,
	"./events5/illum_2.JPG": 31791,
	"./events5/illum_3.jpg": 39903,
	"./events5/illuma.jpg": 83148,
	"./events5/image1.jpg": 24508,
	"./events5/image1.png": 71992,
	"./events5/image10.jpg": 92622,
	"./events5/image11.jpg": 19083,
	"./events5/image12.jpg": 51388,
	"./events5/image13.jpg": 48761,
	"./events5/image14.png": 36910,
	"./events5/image15.jpg": 75175,
	"./events5/image16.png": 95644,
	"./events5/image17.jpg": 3509,
	"./events5/image18.png": 78114,
	"./events5/image19.jpg": 78979,
	"./events5/image19.webp": 84031,
	"./events5/image19_1.jpg": 78519,
	"./events5/image19_2.jpg": 39848,
	"./events5/image19_3.jpeg": 92154,
	"./events5/image19_4.jpg": 24574,
	"./events5/image19_5.jpg": 44731,
	"./events5/image19_6.jpg": 18284,
	"./events5/image19_7.jpg": 16073,
	"./events5/image19_8.jpg": 33362,
	"./events5/image19_9.jpg": 9743,
	"./events5/image19_re.jpg": 27331,
	"./events5/image2.jpg": 9163,
	"./events5/image20.png": 85915,
	"./events5/image20_2.jpeg": 16561,
	"./events5/image20_3.jpeg": 33066,
	"./events5/image20_4.jpeg": 32875,
	"./events5/image21.jpg": 45366,
	"./events5/image22.jpg": 34945,
	"./events5/image23.jpg": 56900,
	"./events5/image24.jpg": 34863,
	"./events5/image24.png": 58911,
	"./events5/image25.jpg": 66930,
	"./events5/image26.jpg": 76829,
	"./events5/image27.jpg": 21248,
	"./events5/image28.jpg": 26715,
	"./events5/image29.jpg": 71934,
	"./events5/image29.webp": 13252,
	"./events5/image3.png": 62538,
	"./events5/image30.jpg": 40948,
	"./events5/image31.jpg": 55281,
	"./events5/image32.jpg": 27526,
	"./events5/image33.jpg": 87011,
	"./events5/image34.png": 8660,
	"./events5/image35.jpg": 62957,
	"./events5/image36.jpg": 17026,
	"./events5/image37.jpg": 8735,
	"./events5/image38.jpg": 34012,
	"./events5/image39.jpg": 55065,
	"./events5/image4.jpg": 50389,
	"./events5/image40.png": 80001,
	"./events5/image41.png": 58872,
	"./events5/image42.jpg": 79691,
	"./events5/image43.jpg": 1646,
	"./events5/image44.png": 16293,
	"./events5/image45.jpg": 32952,
	"./events5/image46.jpg": 12935,
	"./events5/image47.jpg": 61546,
	"./events5/image48.jpg": 32657,
	"./events5/image49.jpg": 44500,
	"./events5/image5.png": 62876,
	"./events5/image50.png": 69958,
	"./events5/image51.jpg": 27775,
	"./events5/image52.jpg": 43440,
	"./events5/image53.jpg": 44365,
	"./events5/image54.png": 60930,
	"./events5/image55.jpg": 85091,
	"./events5/image56.jpg": 6964,
	"./events5/image57.jpg": 4337,
	"./events5/image58.png": 43022,
	"./events5/image59.png": 33015,
	"./events5/image6.jpg": 42407,
	"./events5/image60.jpg": 84839,
	"./events5/image61.png": 46574,
	"./events5/image62.png": 18373,
	"./events5/image63.png": 5308,
	"./events5/image64.png": 88915,
	"./events5/image65.png": 33706,
	"./events5/image66.jpg": 58425,
	"./events5/image67.png": 14424,
	"./events5/image68.png": 81903,
	"./events5/image69.png": 42886,
	"./events5/image7.jpg": 74666,
	"./events5/image70.jpg": 264,
	"./events5/image71.jpg": 27429,
	"./events5/image72.png": 17214,
	"./events5/image73.jpg": 68663,
	"./events5/image74.png": 13384,
	"./events5/image75.jpg": 25513,
	"./events5/image76.png": 45018,
	"./events5/image77.jpg": 30267,
	"./events5/image78.jpg": 21920,
	"./events5/image79.png": 48877,
	"./events5/image8.jpg": 45777,
	"./events5/image80.jpg": 72621,
	"./events5/image81.jpg": 4048,
	"./events5/image82.jpg": 18399,
	"./events5/image83.png": 58246,
	"./events5/image84.jpg": 64945,
	"./events5/image85.jpg": 50612,
	"./events5/image86.png": 68235,
	"./events5/image87.jpg": 37190,
	"./events5/image88.jpg": 20085,
	"./events5/image89.jpg": 12216,
	"./events5/image9.jpg": 73972,
	"./events5/image90.jpg": 23318,
	"./events5/image91.png": 88667,
	"./events5/image92.jpg": 94884,
	"./events5/image93.jpg": 72929,
	"./events5/image94.jpg": 61234,
	"./events5/image95.jpg": 37615,
	"./events5/image96.png": 7012,
	"./events5/image97.jpg": 80189,
	"./events5/logo.png": 47461,
	"./events5/ml.jpg": 82127,
	"./events5/ml1.jpg": 76098,
	"./events5/ml2.JPG": 24396,
	"./events5/placement.jpeg": 75548,
	"./events5/placement_1.jpeg": 72624,
	"./events5/project_expo.png": 11462,
	"./events5/promo.jpeg": 26532,
	"./events5/promo_1.jpeg": 89544,
	"./events5/protocol_zero_0.jpg": 91814,
	"./events5/protocol_zero_1.jpg": 13987,
	"./events5/protocol_zero_2.jpg": 35860,
	"./events5/prrr.jpeg": 58551,
	"./events5/python.png": 22486,
	"./events5/query_quest_0.png": 85840,
	"./events5/query_quest_1.png": 92089,
	"./events5/query_quest_2.png": 36002,
	"./events5/r.jpg": 26104,
	"./events5/r_1.jpg": 99144,
	"./events5/replicon_1.png": 32932,
	"./events5/replicon_2.png": 18207,
	"./events5/replicon_3.png": 64406,
	"./events5/seek.jpeg": 61037,
	"./events5/sh_26_0.jpg": 47483,
	"./events5/sh_26_1.jpg": 76350,
	"./events5/sh_26_2.jpg": 50057,
	"./events5/soft.png": 40124,
	"./events5/soft_hack.jpg": 46810,
	"./events5/software.jpg": 87523,
	"./events5/stack1.jpg": 72365,
	"./events5/stacktrack.jpg": 6801,
	"./events5/talk.jpg": 70050,
	"./events5/talk_1.JPG": 10697,
	"./events5/tech spectrum.jpg": 48071,
	"./events5/tech_symp.jpeg": 26739,
	"./events5/tech_symp_1.png": 13622,
	"./events5/techspec1 (1).JPG": 78703,
	"./events5/techspec1 (1).webp": 57148,
	"./events5/techspec1 (2).JPG": 83850,
	"./events5/techspec1 (2).webp": 20695,
	"./events5/techspec3.JPG": 88443,
	"./events5/teck talks.png": 54102,
	"./events5/teck talks_1.png": 16802,
	"./events5/tesseract.png": 41196,
	"./events5/tesseract_1.jpg": 59960,
	"./events5/tesseract_2.jpg": 76455,
	"./events5/tt_0.jpg": 30381,
	"./events5/tt_1.jpg": 78160,
	"./events5/tt_2.png": 97551,
	"./events5/visionquest.jpeg": 65093,
	"./events5/visionquest_1.jpeg": 41757,
	"./events5/visionquest_2.jpeg": 72508,
	"./events5/wcc.jpeg": 68528,
	"./events5/wcc3.0.jpg": 31742,
	"./events5/wcc3_1.jpg": 34184,
	"./events5/wcc3_1.png": 70348,
	"./events5/wcc3_2.jpg": 18935,
	"./events5/wcc3_3.jpg": 55098,
	"./events5/wcc4.0.jpg": 92217,
	"./events5/wcc4_vol.jpg": 4525,
	"./events5/wcc5_0.jpg": 63847,
	"./events5/wcc5_1.png": 25582,
	"./events5/wcc5_2.png": 13733,
	"./events5/wcc6_0.jpg": 17836,
	"./events5/wcc6_1.jpg": 63209,
	"./events5/wcc6_2.jpg": 89502,
	"./events5/web2.0.JPG": 19117,
	"./events5/web2.0_1.JPG": 67669,
	"./events5/web_winners.jpg": 18809,
	"./events5/webathon 3.0 final.png": 95661,
	"./events5/webathon 3.jpg": 16143,
	"./events5/webathon2.0.jpg": 65478,
	"./events5/webathon_4_0.jpg": 18940,
	"./events5/webathon_4_1.png": 45025,
	"./events5/webathon_4_2.jpg": 48270,
	"./events5/websculpt.jpg": 94685,
	"./events5/websculpt_1.jpg": 34245,
	"./events5/websculpt_2.jpg": 11642,
	"./events5/websculpt_3.JPG": 19326,
	"./events5/what .jpeg": 93753,
	"./events5/what_1.jpeg": 84563,
	"./events5/winner1.png": 63996,
	"./events5/winner2.png": 22103,
	"./events5/winner3.png": 92878,
	"./events5/winner4.png": 10593,
	"./events5/winner5.png": 89464,
	"./events5/ws1.jpg": 35093,
	"./events5/ws2.jpg": 10954,
	"./events5/ws3.jpg": 6759,
	"./events5/ws4.jpg": 52348,
	"./events5/ws5.jpg": 96697,
	"./faculty/facultycor1.jpg": 73471,
	"./faculty/facultycor2.jpeg": 43993,
	"./faculty/ithod.jpg": 46442,
	"./faculty/princi.jpg": 84459,
	"./faculty/principal.png": 28988,
	"./ourTeam2021-22/Akhil.jpg": 83112,
	"./ourTeam2021-22/Akshitha.jpeg": 42525,
	"./ourTeam2021-22/Anirudh.jpeg": 33443,
	"./ourTeam2021-22/Avighna.jpeg": 30604,
	"./ourTeam2021-22/Dhanush.JPG": 11751,
	"./ourTeam2021-22/Nithin.jpeg": 90814,
	"./ourTeam2021-22/Samhith.jpeg": 54044,
	"./ourTeam2021-22/Sanjana.jpeg": 33786,
	"./ourTeam2021-22/Shravani.jpg": 69693,
	"./ourTeam2021-22/Sravani.jpeg": 8096,
	"./ourTeam2021-22/Vamshi.jpg": 50725,
	"./ourTeam2021-22/Varshitha.jpeg": 10256,
	"./projects/attendanceapp (2).jpg": 22245,
	"./projects/attendanceapp.jpg": 69378,
	"./projects/billsample.png": 53703,
	"./projects/certificates.png": 46610,
	"./projects/mailing.png": 2887,
	"./projects/sample.jpg": 79396,
	"./team18/adithys.jpg": 77602,
	"./team18/anuhya.jpg": 79188,
	"./team18/anushka.jpg": 37085,
	"./team18/aryan.jpg": 7033,
	"./team18/glory.jpg": 93821,
	"./team18/jyothsna.jpg": 94534,
	"./team18/kavitha.jpg": 4226,
	"./team18/saikumar.jpg": 79899,
	"./team18/sanjana.jpg": 23940,
	"./team18/tharanya.jpg": 55650,
	"./team18/triveni.jpg": 60229,
	"./team18/vinjam.jpg": 51873,
	"./team19/Tresurer.jpeg": 518,
	"./team19/chair.jpeg": 56825,
	"./team19/membership.jpeg": 63820,
	"./team19/sceretary.jpeg": 8390,
	"./team19/vice chair.jpeg": 29680,
	"./team19/web master.jpeg": 26236,
	"./team20/chair.png": 20340,
	"./team20/coding.jpeg": 15510,
	"./team20/coding.jpg": 85505,
	"./team20/design.jpeg": 91598,
	"./team20/membership.jpeg": 30668,
	"./team20/pr.jpeg": 14078,
	"./team20/sceretary.png": 56921,
	"./team20/sm_head.jpeg": 53295,
	"./team20/technical.jpeg": 53091,
	"./team20/treasurey.jpeg": 21964,
	"./team20/vice_chair.jpeg": 13499,
	"./team20/web master.jpeg": 4700,
	"./team21/2.jpg": 26956,
	"./team21/chair.png": 83081,
	"./team21/coding.png": 25506,
	"./team21/design.png": 26154,
	"./team21/gs.png": 4330,
	"./team21/membership.png": 34860,
	"./team21/pr.png": 64050,
	"./team21/sm.png": 35616,
	"./team21/technical.png": 98383,
	"./team21/tresury.png": 10902,
	"./team21/vice_chair.png": 8381,
	"./team21/webmaster.png": 94946,
	"./team22/Akhil.jpg": 58390,
	"./team22/Akshitha.jpeg": 61959,
	"./team22/Anirudh.jpeg": 99185,
	"./team22/Avighna.jpeg": 67742,
	"./team22/Dhanush.JPG": 42197,
	"./team22/Nithin.jpeg": 65432,
	"./team22/Samhith.jpeg": 18158,
	"./team22/Sanjana.jpeg": 6344,
	"./team22/Shravani.jpg": 6787,
	"./team22/Sravani.jpeg": 89630,
	"./team22/Vamshi.jpg": 9619,
	"./team22/Varshitha.jpeg": 72050,
	"./team23/chair.jpg": 54267,
	"./team23/coding.jpg": 70484,
	"./team23/creative.jpg": 66393,
	"./team23/design.jpg": 98368,
	"./team23/gs.jpg": 89396,
	"./team23/mem.jpg": 90343,
	"./team23/pr.jpg": 49200,
	"./team23/sm.jpg": 19414,
	"./team23/tech.jpg": 20410,
	"./team23/tresurer.jpg": 860,
	"./team23/vc.jpg": 37747,
	"./team23/webmaster.jpg": 61736,
	"./team24/Abhilash.jpg": 31043,
	"./team24/Abhilash_B.jpg": 22360,
	"./team24/Abhinav.jpg": 43468,
	"./team24/Akhil.jpg": 62964,
	"./team24/Anand.jpg": 55055,
	"./team24/Anvitha.jpg": 34608,
	"./team24/Avighna.jpeg": 96056,
	"./team24/Bhanu.jpg": 18391,
	"./team24/Dhanush.JPG": 35731,
	"./team24/Harshini.jpg": 39521,
	"./team24/Renuka.jpg": 12543,
	"./team24/Ronak.jpg": 30178,
	"./team24/Sai_Manish.jpg": 42527,
	"./team24/SamplePPTWebathon3.0.pptx": 76628,
	"./team24/Shivalini.jpg": 18052,
	"./team24/Shravani.jpg": 30137,
	"./team24/Siddartha.jpg": 14217,
	"./team24/TkinterWorkingAll (2).zip": 66650,
	"./team25/Bavitha.jpg": 48835,
	"./team25/Mani_Shankar.png": 51978,
	"./team25/Murali.jpeg": 13621,
	"./team25/Nikitha.jpeg": 86143,
	"./team25/Shashi.jpg": 52296,
	"./team25/Shradha.jpg": 26129,
	"./team25/Shreshta.jpeg": 77983,
	"./team25/Siri_Chandana.jpg": 58978,
	"./team25/Swapanthi.jpeg": 47880,
	"./team25/Ved.jpeg": 93204,
	"./team25/Vedasi.jpg": 56830,
	"./team25/amritha.jpeg": 21309,
	"./team5/Abhilash.jpg": 5152,
	"./team5/Abhilash_B.jpg": 39391,
	"./team5/Abhinav.jpg": 90581,
	"./team5/Akhil.jpg": 8882,
	"./team5/Akshitha.jpeg": 99364,
	"./team5/Anand.jpg": 55882,
	"./team5/Anirudh.jpeg": 61832,
	"./team5/Anvitha.jpg": 71165,
	"./team5/Avighna.jpeg": 8415,
	"./team5/Bhanu.jpg": 64494,
	"./team5/Dhanush.JPG": 86492,
	"./team5/Harshini.jpg": 68166,
	"./team5/Nithin.jpeg": 28035,
	"./team5/Renuka.jpg": 10300,
	"./team5/Ronak.jpg": 22531,
	"./team5/Sai_Manish.jpg": 35740,
	"./team5/Samhith.jpeg": 57619,
	"./team5/SamplePPTWebathon3.0.pptx": 42655,
	"./team5/Sanjana.jpeg": 21825,
	"./team5/Shivalini.jpg": 20489,
	"./team5/Shravani.jpg": 4430,
	"./team5/Siddartha.jpg": 56444,
	"./team5/Sravani.jpeg": 24303,
	"./team5/TkinterWorkingAll (2).zip": 82293,
	"./team5/Vamshi.jpg": 26754,
	"./team5/Varshitha.jpeg": 90587,
	"./teamIcons/creative.png": 56402,
	"./teamIcons/group.png": 78892,
	"./timeline.png": 49958,
	"./upcomingPosters/techSpotlight.jpeg": 60575,
	"./upcomingPosters/wcc3.png": 74944,
	"./upcomingPosters/wcc4.0.jpg": 80725,
	"./upcomingPosters/wcc5.0.jpg": 18164,
	"./upcomingPosters/wcc6.png": 80941,
	"./upcomingPosters/webahon3.0.jpg": 49703,
	"./upcomingPosters/webathon4.0.png": 48768,
	"./volunteers/avatar.png": 13512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79743;